<template>
  <div class="forget-form-container">
    <div class="forget-form">
      <div class="forget-container" id='forgetContainer'>
        <div class="title">{{ $t('jtRegisterForm.TITLE') }}</div>
        <!-- <div class="row">
          <div class="col-label">
            <span>*</span>
            {{ $t('jtRegisterForm.LABEL_USERNAME') }}
          </div>
          <div class="col-content">
            <el-input v-model="username"></el-input>
          </div>
        </div> -->
        <div class="row">
          <div class="col-label">
            <span>*</span>
            {{ $t('jtRegisterForm.LABEL_EMAIL') }}
          </div>
          <div class="col-content">
            <el-tooltip
              :content="$t('jtRegisterForm.EMAIL_PLACEHOLDER')"
              placement="top-start"
            >
              <el-input v-model="email"></el-input>
            </el-tooltip>
          </div>
        </div>
        <div class="btn-container">
          <el-button
            type="primary"
            @click="infoconfirm"
            :disabled="registerBtnDisabled"
          >
            <span class="yahei">{{ $t('jtRegisterForm.BTN_CONFIRM') }}</span>
          </el-button>
        </div>
        <div class="footer-container">
          <router-link :to="url" style="color: #f00">{{
            $t('jtRegisterForm.LABEL_USER_LOGIN')
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import _ from 'lodash'
import * as constants from '../../constants'
import * as storage from '../../utils/storage'
import Validator from '../../utils/validator.js'
import UserModel from '../../models/user'

export default {
  name: 'Forgetpassword',
  data() {
    return {
      username: '',
      email: '',
      game: {},
    }
  },
  computed: {
    registerBtnDisabled() {
      return _.isEmpty(this.email)
    },

    url() {
      return '/login.html?gameId=' + this.game.id
    },
  },
  methods: {
    async infoconfirm() {
      try {
        const info = this.validate()
        const data = await UserModel.forgetPassword(info)
        let msg = this.$t('jtRegisterForm.TIPS_ERROR')
        let title = this.$t('jtRegisterForm.TIPS_TITLE_ERROR')
        let ok = this.$t('page.SUBMIT_CONFIRM_OK')
        let type = 'error'
        if (data) {
          msg = this.$t('jtRegisterForm.TIPS_SUCCESS')
          title = this.$t('jtRegisterForm.TIPS_TITLE_SUCCESS')
          type = 'success  '
        }
        this.$msgbox({
          title: title,
          message: msg,
          showCancelButton: true,
          confirmButtonText: ok,
          showCancelButton: false,
          type: type,
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    validate() {
      const gameId = this.game.id
      // const username = this.username.trim()
      const email = this.email.trim()
      const errMsg = this.$t('email.INCORRECT_EMAIL_FORMAT', { email })
      Validator.isEmail(email, errMsg)
      return { email, gameId }
    },
  },
  async mounted() {
    const router = this.$router
    const gameId = router.history.current.query.gameId
    let gameList = storage.getItem(constants.GAME_LIST)
    if (gameId == null) {
      this.$message.error(this.$t('jtRegisterPage.GAME_ID_IS_NULL'))
      router.push('/login.html')
      return
    }
    this.game = _.find(gameList, (item) => item.id === parseInt(gameId))

    if (storage.getItem('bannerUrl')) {
      let ele = document.getElementById('forgetContainer')
      ele.style.border = 'none'
      ele.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
    }
  },
}
</script>

<style lang="stylus" scoped>
.forget-form-container {
  height: 100%;

  .forget-form {
    min-height: calc(100% - 3em);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .forget-container {
    width: 41%;
    min-height: 320px;
    padding: 16px;
    border: 2px solid gray;
    background-color: #f5f5f5;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .title {
    line-height: 36px;
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
  }

  .row {
    height: 32px;
    line-height: 32px;
    margin-bottom: 26px;
    display: flex;
    flex-direction: row;

    .col-label {
      width: 30%;
      text-align: right;
      padding-right: 10px;

      &:after {
        content: ': ';
      }

      span {
        color: red;
      }
    }

    .col-content {
      height: 32px;
      line-height: 32px;
      width: 300px;
    }
  }

  .btn-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .el-button {
      font-size: 16px;
      width: 40%;
    }
  }

  .footer-container {
    padding-top: 16px;
    display: flex;
    flex-direction: row-reverse;
  }
}

@media screen and (max-width: 768px) {
  .forget-form-container {
    .forget-container {
      width: 85%;
    }
  }
}
</style>
